export default function Divider({ style }: { style?: Object }) {
  return <div style={{ ...divider, ...style }}></div>;
}

const divider = {
  height: 1,
  backgroundColor: "#E8E8E8",
  width: "100%",
};
